class ErrorHandlerService {
	static handle (error: Error): void {
		if (process.env.NODE_ENV === "development") {
			console.error("[ERROR]: ", error)
		}
	}
}

export default ErrorHandlerService
